import type { ComponentProps } from 'react';
type Props = {
  variant?: 'muted' | 'active' | 'primary' | 'fill';
} & ComponentProps<'svg'>;
export const AccountIcon = ({
  variant = 'primary',
  ...rest
}: Props) => {
  switch (variant) {
    case 'muted':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <path fill="#646467" d="M5 16.95c0 3.85 0 3.85 7 3.85s7 0 7-3.85-3.134-3.85-7-3.85-7 0-7 3.85Zm10.5-8.917C15.5 9.966 13.933 11 12 11S8.5 9.966 8.5 8.033 10.067 4 12 4s3.5 2.1 3.5 4.033Z" />
        </svg>;
    case 'active':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <path fill="#646467" d="M5 16.95c0 3.85 0 3.85 7 3.85s7 0 7-3.85-3.134-3.85-7-3.85-7 0-7 3.85Z" />
          <path fill="#546195" d="M15.5 8.033C15.5 9.966 13.933 11 12 11S8.5 9.966 8.5 8.033 10.067 4 12 4s3.5 2.1 3.5 4.033Z" />
        </svg>;
    case 'primary':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <path fill="#00082C" fillOpacity=".9" d="M5 16.95c0 3.85 0 3.85 7 3.85s7 0 7-3.85-3.134-3.85-7-3.85-7 0-7 3.85Zm10.5-8.917C15.5 9.966 13.933 11 12 11S8.5 9.966 8.5 8.033 10.067 4 12 4s3.5 2.1 3.5 4.033Z" />
        </svg>;
    case 'fill':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <path fill="#fff" d="M5 16.95c0 3.85 0 3.85 7 3.85s7 0 7-3.85-3.134-3.85-7-3.85-7 0-7 3.85Zm10.5-8.917C15.5 9.966 13.933 11 12 11S8.5 9.966 8.5 8.033 10.067 4 12 4s3.5 2.1 3.5 4.033Z" />
        </svg>;
  }
};